<template>
    <div class="flex flex-col w-full justify-center gap-2 md:gap-2">
        <vx-box class="bg-slate-50 flex flex-col max-w-(--breakpoint-sm) p-8 text-xl mb-8" color="info">
            <h2 class="text-xl font-extrabold leading-7 text-slate-700">Promotions</h2>
            <p class="text-sm font-sans text-slate-500 lg:text-base">Codes sent to this contact.</p>
        </vx-box>

        <div v-if="loading && !list.length" class="text-center py-10">
            <vx-icon-loading class="w-9 h-9 animate-loading-spin"></vx-icon-loading>
        </div>

        <template v-else-if="!loading && list.length === 0">
            <vx-box color="info" class="mt-8 flex flex-col px-8 py-20 gap-6 items-center text-xl text-slate-500">
                There are no promotions for this contact.
            </vx-box>
        </template>
        <template v-else>
            <vx-table v-if="list.length" class="xl:grid-cols-6" rowBreakpoint="xl">
                <vx-table-row isHeader>
                    <div class="xl:col-span-3">Name</div>
                    <div class="xl:col-span-2!">Coupon</div>
                    <div>Allocated on</div>
                </vx-table-row>
                <contact-promotion-row
                    v-for="(item, index) in list"
                    v-model="list[index]"
                    :key="item.id"
                ></contact-promotion-row>
            </vx-table>

            <div v-if="list.length" class="mt-8 flex justify-between w-full gap-10">
                <vx-button
                    v-if="fetchParams.cursor"
                    @click="loadData()"
                    data-test="load-more-btn"
                    color="muted-dark"
                    size="xl"
                    class="grow-0"
                    :loading="loading"
                >
                    Load More
                    <font-awesome-icon widthAuto :icon="faSpinner"></font-awesome-icon>
                </vx-button>
            </div>
        </template>
    </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBox, VxButton, VxIconLoading, VxTable, VxTableRow } from '@voxie/frontend-components';
import { useCursorPagination } from '../../../../composables/useCursorPagination';
import { contactsClient } from '~/services';
import ContactPromotionRow from './ContactPromotionRow.vue';
import { onMounted } from 'vue';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

const { list, loading, fetchParams, fetchRecords } = useCursorPagination();

const props = defineProps({
    contactId: {
        type: Number,
        required: true,
    },
});

const defaultFilters = () => {
    return {
        per_page: 100,
        cursor: null,
        sort_dir: 'desc',
    };
};

onMounted(() => {
    fetchParams.value = defaultFilters();
    loadData();
});

const loadData = () => {
    fetchRecords(contactsClient.listPromotionCoupons(Spark.state.currentTeam.id, props.contactId, fetchParams.value));
};
</script>
